module.exports = __webpack_public_path__ + "assets/img/h1.8b1d3dc1.jpg";